<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 md6 offset-md3>
        <assignment
          v-for="(assignment, i) in assignments"
          :key="i"
          :assignment="assignment"
        ></assignment>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Assignment from './Assignment.vue'
export default {
  props: ['assignments'],
  components: { Assignment }
}
</script>



// WEBPACK FOOTER //
// src/components/Instructor/Classroom/Assignments.vue